import ZonesComponent from "../../../Components/system settings/ZonesComponent";
import HeaderBar from "../../../Components/UI/headerbar";

const ZonesPage = () => {
  return (
    <div>
      <HeaderBar
        title={"إعدادات المناطق"}
        content={"إدارة المناطق الجغرافية للنظام"}
      />

      <ZonesComponent />
    </div>
  );
};

export default ZonesPage;
